import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const HolidayList = lazy(() => import('./components/List'))
const HolidayCreate = lazy(() => import('./components/Create'))
const HolidayUpdate = lazy(() => import('./components/Update'))

const HolidayModule: RouteObject = {
    path: 'workdays/holiday',
    children: [
        {
            path: '',
            element: <HolidayList />,
        },
        {
            path: 'new',
            element: <HolidayCreate />,
        },
        {
            path: ':holidayID',
            element: <HolidayUpdate />,
        },
    ],
}
export default HolidayModule
